import type { LayoutShiftStats } from '@confluence/browser-metrics/entry-points/getLayoutShiftWithAttribution.ts';
import {
	pageLoadEventPlugin,
	customEventPlugin,
	ssrRegionPlugin,
	frontendNetworkPlugin,
} from '@confluence/browser-metrics/entry-points/plugins.ts';
import { getBuildInfo } from '@confluence/build-info';

declare global {
	interface Window {
		__PO_ASSET_DISPLAYED__?: boolean;
	}
}

export const additionalPayloadData = (
	interaction: {
		end: number;
		start: number;
		ufoName: string;
	},
	otherMetadataFromSessionData: {
		cloudId: string;
		isShardPreProd: boolean;
		layoutShiftWithAttribution: Record<string, LayoutShiftStats>;
	},
) => {
	const buildInfoData = getBuildInfo();
	const buildInfo: any = {};

	if (buildInfoData) {
		Object.keys(buildInfoData).forEach((item) => {
			const newKey = `buildInfo:${item}`;
			buildInfo[newKey] = (buildInfoData as any)[item];
		});
	}

	const data = {
		...pageLoadEventPlugin({
			stop: interaction.end,
			start: interaction.start,
			key: interaction.ufoName,
		}),
		...customEventPlugin({
			stop: interaction.end,
			start: interaction.start,
			key: interaction.ufoName,
		}),
		...frontendNetworkPlugin({
			stop: interaction.end,
			start: interaction.start,
			key: interaction.ufoName,
		}),
		...ssrRegionPlugin(),
		...buildInfo,
		...otherMetadataFromSessionData,

		postOfficeAssetsDisplayed: window.__PO_ASSET_DISPLAYED__,
	};

	return {
		confluence: data,
	};
};
